module.exports = __webpack_public_path__ + "static/media/abbiamo3.d93e91ed.png";